/**
 * check if an object is empty
 * @param obj the object to check
 * @returns true if the object is empty
 */
const isObjectEmpty = (obj: object | null | undefined) => {
    return obj == null || Object.keys(obj).length === 0;
};

export { isObjectEmpty };
